import React, { FC } from 'react';
import { useGetShopifyList } from '@services/toys/hooks/useGetShopifyList';
import { LogoLoader } from '@components/UIKit/LogoLoader/LogoLoader';
import { ShopifyItem } from '@components/Cards/ShopifyItem/ShopifyItem';
interface Props {}
export const PhysicalToysList: FC<Props> = ({}) => {
  const {
    data,
    isLoading
  } = useGetShopifyList({
    status: 'ACTIVE'
  });
  if (isLoading) return <LogoLoader />;
  if (!data?.products.length) return null;
  return <div className={'_toysGrid'} data-sentry-component="PhysicalToysList" data-sentry-source-file="PhysicalToysList.tsx">
						{data.products.map(item => <ShopifyItem key={item.id} {...item} />)}
				</div>;
};